// en_pms_billing.ts
// Tłumaczenia dla PMS.Billing.tsx

export const enPmsBilling = {

  title:       "Billing",
  description: "Guest folios, split billing, refunds, adjustments, invoices and fiscal readiness.",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    folioWorkspace:      "Folio workspace",
    folioActivity:       "Folio activity",
    postCharges:         "Post charges",
    refundsAdjustments:  "Refunds & adjustments",
    invoicesFiscal:      "Invoices & fiscal",
    groupBillingSnapshot:"Group billing snapshot",
  },

  // ── Opisy sekcji ─────────────────────────────────────────────────────────
  descriptions: {
    chargeWorkflow:  "Charge posting, settlement, invoicing and adjustment workflow.",
    currentItems:    "Current items, payments and refunds for the selected folio.",
    controlledReversal:"Controlled reversal and adjustment workflow.",
    partialPayments: "Partial and split payments across multiple methods.",
    generateInvoice: "Generate an invoice and route it through the fiscal integration abstraction.",
    groupFolioSummary:"Group folio summary remains available.",
  },

  // ── Metody płatności ──────────────────────────────────────────────────────
  paymentMethods: {
    card:      "Card",
    cash:      "Cash",
    noPayment: "No payment",
    methodOne: "Payment method 1",
    methodTwo: "Payment method 2",
  },

  // ── Kategorie opłat ───────────────────────────────────────────────────────
  chargeCategories: {
    minibar:    "Minibar",
    lateCharge: "Late charge",
    other:      "Other",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    folio:            "Folio",
    invoice:          "Invoice",
    fiscalizedInvoice:"Faktura fiskalna",
    chargeCategory:   "Kategoria opłaty",
    balanceDue:       "Saldo do zapłaty",
    activeFolio:      "Aktywne folio",
    billingCompany:   "Billing company",
    noFolioSelected:  "No folio selected",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    adjustmentFailed: "Korekta nieudana.",
    chargeFailed:     "Księgowanie opłaty nieudane.",
    invoiceFailed:    "Invoice generation failed.",
    refundFailed:     "Zwrot nieudany.",
  },

} as const;

export default enPmsBilling;
